import { handleGaTracking } from "../utils/js/tracking";

class TPL_Transverse_Newsletter {
  constructor(componentHost) {
    this.componentHost = componentHost;

    this.mainWrapper = this.componentHost.querySelector(".newsletter");

    if (!this.mainWrapper) return;

    this.initEvents();
  }

  initEvents() {
    this.cellB376();
  }

  cellB376() {
    window.addEventListener("newsletter-open-form", () => {
      handleGaTracking({
        node: this.mainWrapper,
        eventName: "menu_interact",
        additionalData: {
          bloc_name: "newsletter",
          bloc_interaction: "open newsletter form",
        },
      });
    });
  }
}

new TPL_Transverse_Newsletter(document.body);
